import { useQuery } from "@tanstack/react-query";
import { useContainer } from "@src/contexts/container-context";

/**
 * Hook to fetch integration providers
 * @param {Object} params - Parameters for getProviders (e.g., { includeDisabled: true })
 * @param {Object} options - Additional react-query options
 * @returns {Object} React Query result object
 */
export function useProviders(params = {}, options = {}) {
  const { integrationService } = useContainer();

  return useQuery({
    queryKey: ["providers", params],
    queryFn: () => integrationService.getProviders(params),
    enabled: options.enabled !== false,
    ...options,
  });
}
